import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectAnullStatus = createSelector(
  [(store: RootState) => store.documentUpdate.anullStatus],
  (data) => data
);
